import { render, staticRenderFns } from "./RoadMap.vue?vue&type=template&id=20389c30"
import script from "./RoadMap.vue?vue&type=script&lang=js"
export * from "./RoadMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports